exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SOIbVgi8zeIwEgur9Zg9m {\n    aspect-ratio: 16/9;\n    border: none;\n}", ""]);

// exports
exports.locals = {
	"root": "SOIbVgi8zeIwEgur9Zg9m"
};